import { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter,
} from "@/components/ui/dialog";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import { parseApiError } from "@/lib/apiErrors";

const BLANK = { email: "", role: "Executive", name: "" };

export default function InviteUserDialog({ onInvited }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(BLANK);

  const send = async () => {
    try {
      await api.post("/invites", form);
      toast.success(`Invited ${form.email}`);
      setOpen(false);
      setForm(BLANK);
      onInvited?.();
    } catch (e) { toast.error(parseApiError(e, "Failed")); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="bg-[#0a2540] hover:bg-[#0f2f50] rounded-sm" data-testid="btn-invite">
          <Mail size={14} className="mr-1.5" /> Invite Employee
        </Button>
      </DialogTrigger>
      <DialogContent className="rounded-sm">
        <DialogHeader><DialogTitle style={{ fontFamily: "Outfit" }}>Invite Employee</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div>
            <Label className="text-xs">Email * (@griffinconsultancy.in)</Label>
            <Input className="mt-1 rounded-sm font-mono-data" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="input-invite-email" />
          </div>
          <div>
            <Label className="text-xs">Name (optional)</Label>
            <Input className="mt-1 rounded-sm" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="input-invite-name" />
          </div>
          <div>
            <Label className="text-xs">Role</Label>
            <Select value={form.role} onValueChange={(v) => setForm({ ...form, role: v })}>
              <SelectTrigger className="mt-1 rounded-sm" data-testid="select-invite-role"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="Admin">Admin</SelectItem>
                <SelectItem value="Manager">Manager</SelectItem>
                <SelectItem value="Executive">Executive</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="text-[11px] text-slate-500 bg-slate-50 border border-slate-200 p-3">
            The invitee will sign in via Google Workspace using their <span className="font-mono-data">@griffinconsultancy.in</span> email.
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" className="rounded-sm" onClick={() => setOpen(false)}>Cancel</Button>
          <Button className="bg-[#0a2540] hover:bg-[#0f2f50] rounded-sm" onClick={send} data-testid="btn-send-invite">Send Invite</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
